import api from './api';

export interface ChannelInstancePayload {
  channelType: string;
  instanceName: string;
  config?: Record<string, any>;
}

export interface UpdateChannelInstancePayload {
  instanceName?: string;
  config?: Record<string, any>;
}

export interface ChannelInstanceResponse {
  id: string;
  tenantId: string;
  channelType: string;
  instanceName: string;
  externalId?: string;
  status: string;
  config: Record<string, any>;
  metadata: Record<string, any>;
  createdAt: string;
  updatedAt: string;
}

export interface ChannelBusinessProfileResponse {
  instanceId: string
  channelType: string
  accountType: 'business' | 'personal' | 'unknown'
  verifiedName: string | null
  businessProfile: Record<string, any> | null
  syncedAt: string | null
  metadata: Record<string, any>
}

export const listChannelInstances = async (): Promise<ChannelInstanceResponse[]> => {
  const { data } = await api.get('/api/channels/instances');
  return data;
};

export const createChannelInstance = async (payload: ChannelInstancePayload): Promise<ChannelInstanceResponse> => {
  const { data } = await api.post('/api/channels/instances', payload);
  return data;
};

export const updateChannelInstance = async (
  id: string,
  payload: UpdateChannelInstancePayload
): Promise<ChannelInstanceResponse> => {
  const { data } = await api.put(`/api/channels/instances/${id}`, payload);
  return data;
};

export const validateTelegramToken = async (botToken: string): Promise<{
  valid: boolean;
  bot?: {
    id: number;
    username: string | null;
    firstName: string | null;
  };
  error?: string;
}> => {
  const { data } = await api.post('/api/channels/telegram/validate', { botToken });
  return data;
};

export const deleteChannelInstance = async (id: string): Promise<void> => {
  await api.delete(`/api/channels/instances/${id}`);
};

export const reconnectChannelInstance = async (id: string): Promise<void> => {
  await api.post(`/api/channels/instances/${id}/reconnect`);
};

export const getChannelInstanceStatus = async (id: string): Promise<{ status: string }> => {
  const { data } = await api.get(`/api/channels/instances/${id}/status`);
  return data;
};

export const getChannelInstanceQr = async (id: string): Promise<{ qr: string | null }> => {
  const { data } = await api.get(`/api/channels/instances/${id}/qr`);
  return data;
};

export const getChannelBusinessProfile = async (id: string): Promise<ChannelBusinessProfileResponse> => {
  const { data } = await api.get(`/api/channels/instances/${id}/business-profile`);
  return data;
};
